// extracted by mini-css-extract-plugin
export var section = "styles-module--section--8IOcM";
export var titleContainer = "styles-module--titleContainer--2sYKO";
export var title = "styles-module--title--ysnse";
export var content = "styles-module--content--pz8rz";
export var columnContent = "styles-module--columnContent--BcHvV";
export var cardContent = "styles-module--cardContent--1ke70";